import { KeyCodes } from 'bootstrap-vue/src/utils';

export default {
    bind(el, binding, vnode) {
        let targetHref;
        let isModalShowing = false;

        if(el.tagName === 'A') {
            targetHref = el.getAttribute('href');
        } else {
            targetHref = el.getAttribute('target-href');
            el.setAttribute('tabindex', '0');
        }

        el.addEventListener('click', (evt) => {
            evt.preventDefault();

            isModalShowing = true;
            vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
        });

        el.addEventListener('keypress', (evt) => {
            evt.preventDefault();

            if(evt.keyCode === KeyCodes.ENTER) {
                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        vnode.context.$root.$on('bv::modal::show', (evt) => {
            if(isModalShowing) {
                if(window.activeSpeedBumpLink) {
                    const speedBumpLink = document.querySelector('#speed-bump-link');

                    setModalContent(evt.vueTarget.$vnode.context.$refs, speedBumpLink.getAttribute('href'));
                } else {
                    setModalContent(evt.vueTarget.$vnode.context.$refs, targetHref);
                }
            }
        });

        vnode.context.$root.$on('bv::modal::hide', (evt) => {
            if(isModalShowing) {
                isModalShowing = false;
                setModalContent(evt.vueTarget.$vnode.context.$refs, '');
            }
        });

        vnode.context.$root.$on('bv::modal::hidden', (evt) => {
            if(window.activeSpeedBumpLink) {
                window.activeSpeedBumpLink.focus();
                window.activeSpeedBumpLink = null;
            }
        });

        if(el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            el.setAttribute('role', 'button');
        }

        function setModalContent(refs, value) {
            const text = refs['speed-bump-text'];
            const href = refs['speed-bump-link'];

            if(text) {
                if(value.length > 120) {
                    text.innerHTML = value.substring(0, 120) + '...';
                } else {
                    text.innerHTML = value;
                }
            }

            if(href) {
                href.setAttribute('href', value);

                href.addEventListener('click', function() {
                    setTimeout(() => {
                        vnode.context.$root.$emit('bv::hide::modal', 'speed-bump-modal');
                    }, 250);
                });
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/speed-bump.js